import notification from 'antd/lib/notification';
import 'antd/lib/notification/style/index.less';

export type { NotificationPlacement } from 'antd/lib/notification';

notification.config({
  placement: 'bottomRight',
  bottom: 16,
  duration: 3,
});

// eslint-disable-next-line unicorn/prefer-export-from
export { notification };
